<template>
  <!-- inicio formulario -->

  <div v-if="impressao != null && show"
       id="formulario">
    <b-row class="mt-3">
      <b-col offset="1"
             cols="10"
             align="center">
        <label class="impressao--label"
               for="nome">Nome</label>
        <input id="nome"
               v-model="impressao.nome"
               type="text"
               class="form-control form-control-sm text-center"
               @keyup="changeImpressao">
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col offset="4"
             cols="4"
             align="center">
        <label class="impressao--label"
               for="cpf">Número do CPF</label>
        <input id="cpf"
               v-model="impressao.cpf"
               v-mask="`999.999.999-99`"
               placeholder="NÃO CONSTA"
               type="text"
               class="form-control form-control-sm text-center"
               @keyup="changeImpressao">
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col offset="3"
             cols="6"
             align="center">
        <label class="impressao--label"
               for="matricula">Matrícula</label>
        <input id="matricula"
               v-model="impressao.matricula"
               type="text"
               class="form-control form-control-sm text-center"
               disabled
               @keyup="changeImpressao">
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col cols="5">
        <b-row>
          <b-col>
            <label class="impressao--label"
                   for="data_hora_falecimento">Data do falecimento</label>
            <input id="data_hora_falecimento"
                   v-model="impressao.data_obito"
                   type="text"
                   class="form-control form-control-sm"
                   @keyup="changeImpressao">
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <label class="impressao--label"
                   for="dia">Dia</label>
            <input id="dia"
                   v-model="impressao.dia"
                   type="number"
                   min="0"
                   placeholder="N/C"
                   :disabled="data_desconhecida"
                   class="form-control form-control-sm"
                   @keyup="changeImpressao">
          </b-col>
          <b-col>
            <label class="impressao--label"
                   for="mes">Mês</label>
            <input id="mes"
                   v-model="impressao.mes"
                   type="number"
                   min="0"
                   placeholder="N/C"
                   :disabled="data_desconhecida"
                   class="form-control form-control-sm"
                   @keyup="changeImpressao">
          </b-col>
          <b-col>
            <label class="impressao--label"
                   for="ano">Ano</label>
            <input id="ano"
                   v-model="impressao.ano"
                   type="number"
                   min="0"
                   placeholder="N/C"
                   :disabled="data_desconhecida"
                   class="form-control form-control-sm"
                   @keyup="changeImpressao">
          </b-col>
          <b-col cols="4">
            <label class="impressao--label"
                   for="dia">Horário do falecimento</label>
            <input id="dia"
                   v-model="impressao.horario"
                   type="text"
                   :disabled="data_desconhecida"
                   class="form-control form-control-sm"
                   @keyup="changeImpressao">
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mt-2">
      <b-col>
        <label class="impressao--label"
               for="local_falecimento">Local de falecimento</label>
        <input id="local_falecimento"
               v-model="impressao.local_obito"
               type="text"
               class="form-control form-control-sm"
               @keyup="changeImpressao">
      </b-col>
      <b-col>
        <label class="impressao--label"
               for="municipio_falecimento">Município de falecimento</label>
        <input id="municipio_falecimento"
               v-model="impressao.municipio_obito"
               type="text"
               placeholder="NÃO CONSTA"
               class="form-control form-control-sm"
               @keyup="changeImpressao">
      </b-col>
      <b-col cols="2">
        <label class="impressao--label"
               for="uf_falecimento">UF</label>
        <input id="uf_falecimento"
               v-model="impressao.uf_obito"
               type="text"
               placeholder="N/C"
               class="form-control form-control-sm"
               @keyup="changeImpressao">
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col cols="3">
        <label class="impressao--label"
               for="sexo">Sexo</label>
        <input id="sexo"
               v-model="impressao.sexo"
               type="text"
               class="form-control form-control-sm"
               @keyup="changeImpressao">
      </b-col>
      <b-col cols="3">
        <label class="impressao--label"
               for="estado_civil">Estado Civil</label>
        <input id="estado_civil"
               v-model="impressao.estado_civil"
               type="text"
               class="form-control form-control-sm"
               @keyup="changeImpressao">
      </b-col>
      <b-col>
        <label class="impressao--label"
               for="ultimo_convivente">Nome do último cônjuge ou convivente</label>
        <input id="ultimo_convivente"
               v-model="impressao.ultimo_convivente"
               type="text"
               class="form-control form-control-sm"
               @keyup="changeImpressao">
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col cols="5"
             class="d-flex pl-0">
        <b-col cols="3">
          <label class="impressao--label"
                 for="idade">Idade</label>
          <input id="idade"
                 v-model="impressao.idade"
                 type="text"
                 class="form-control form-control-sm"
                 @keyup="changeImpressao">
        </b-col>
        <b-col cols="3">
          <label class="impressao--label"
                 for="dia">Dia</label>
          <input id="dia"
                 v-model="impressao.idade_dia"
                 type="number"
                 min="0"
                 placeholder="N/C"
                 :disabled="data_desconhecida"
                 class="form-control form-control-sm"
                 @keyup="changeImpressao">
        </b-col>
        <b-col cols="3">
          <label class="impressao--label"
                 for="mes">Mês</label>
          <input id="mes"
                 v-model="impressao.idade_mes"
                 type="number"
                 min="0"
                 placeholder="N/C"
                 :disabled="data_desconhecida"
                 class="form-control form-control-sm"
                 @keyup="changeImpressao">
        </b-col>
        <b-col cols="3">
          <label class="impressao--label"
                 for="ano">Ano</label>
          <input id="ano"
                 v-model="impressao.idade_ano"
                 type="number"
                 min="0"
                 placeholder="N/C"
                 :disabled="data_desconhecida"
                 class="form-control form-control-sm"
                 @keyup="changeImpressao">
        </b-col>
      </b-col>
      <b-col cols="6">
        <label class="impressao--label"
               for="municipio_de_nascimento">Município da naturalidade</label>
        <input id="municipio_de_nascimento"
               v-model="impressao.municipio_de_nascimento"
               type="text"
               placeholder="NÃO CONSTA"
               class="form-control form-control-sm"
               @keyup="changeImpressao">
      </b-col>
      <b-col cols="1">
        <label class="impressao--label"
               for="municipio_de_nascimento_uf">UF</label>
        <input id="municipio_de_nascimento_uf"
               v-model="impressao.municipio_de_nascimento_uf"
               type="text"
               placeholder="N/C"
               class="form-control form-control-sm"
               @keyup="changeImpressao">
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col>
        <SubHeaderGrey class="row mt-3 mb-1">
          <div class="d-flex justify-content-between pb-1 pl-2">
            Genitores
          </div>
        </SubHeaderGrey>
        <b-row v-for="(genitor, index) in genitores"
               :key="index">
          <b-col cols="5">
            <label class="impressao--label"
                   for="nomeGenitor">Nome:</label>
            <input id="nomeGenitor"
                   v-model="genitor.nome"
                   class="form-control form-control-sm"
                   type="text"
                   :name="`genitor_nome${index}`"
                   @change="changeGenitor(genitor)">
          </b-col>
          <b-col cols="1"
                 align-self="center"
                 class="mt-4">
            <b-button size="sm"
                      variant="light"
                      @click="excluirGenitor(index)">
              <svg class="obito-show_icon icon--sm"
                   role="presentation">
                <use :xlink:href="'#' + deleteRedIcon.id" />
              </svg>
            </b-button>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12"
             class="mb-2">
        <button variant="primary"
                class="btn btn-sm btn-add-genitor btn-outline-primary btn-block my-3"
                size="sm"
                @click="novoGenitor">
          <IconSvg class="icon-add icon--sm mr-1"
                   icon="add" />
          Adicionar Genitor
        </button>
      </b-col>
    </b-row>

    <b-row class="w-100 mb-2 ml-0">
      <b-form-checkbox id="data_falecimento_descinhecida"
                       v-model="data_desconhecida"
                       switch
                       @change="dataDesconhecida()"
                       @keyup.native.enter="() => { data_desconhecida = !data_desconhecida; dataDesconhecida(); }">
        Data desconhecida
      </b-form-checkbox>
    </b-row>

    <b-row class="mt-1">
      <b-col>
        <label class="impressao--label"
               for="causa_morte">Causa da Morte</label>
        <textarea id="causa_morte"
                  v-model="impressao.causas_morte"
                  class="form-control form-control-sm"
                  rows="2"
                  @keyup="changeImpressao" />
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col cols="7">
        <label class="impressao--label"
               for="medico_nome">Nome do médico que atestou o óbito ou, se for o caso, das testemunhas</label>
        <input id="medico_nome"
               v-model="impressao.medico_nome"
               type="text"
               class="form-control form-control-sm"
               @keyup="changeImpressao">
      </b-col>
      <b-col cols="5">
        <label class="impressao--label"
               for="medico_crm">Número do documento</label>
        <input id="medico_crm"
               v-model="impressao.medico_crm"
               type="text"
               class="form-control form-control-sm"
               @keyup="changeImpressao">
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col cols="4">
        <label class="impressao--label"
               for="sepultamento_cremacao">Local de sepultamento/Cremação</label>
        <input id="sepultamento_cremacao"
               v-model="impressao.sepultamento_cremacao"
               type="text"
               class="form-control form-control-sm"
               @keyup="changeImpressao">
      </b-col>
      <b-col cols="6">
        <label class="impressao--label"
               for="sepultamento_cremacao_municipio">Município</label>
        <input id="sepultamento_cremacao_municipio"
               v-model="impressao.sepultamento_cremacao_municipio"
               type="text"
               class="form-control form-control-sm"
               @keyup="changeImpressao">
      </b-col>
      <b-col cols="2">
        <label class="impressao--label"
               for="sepultamento_cremacao_uf">UF</label>
        <input id="sepultamento_cremacao_uf"
               v-model="impressao.sepultamento_cremacao_uf"
               type="text"
               class="form-control form-control-sm"
               @keyup="changeImpressao">
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col cols="6">
        <label class="impressao--label"
               for="data_de_registro">Data de registro</label>
        <input id="data_de_registro"
               v-model="impressao.data_de_registro"
               type="text"
               class="form-control form-control-sm"
               @keyup="changeImpressao">
      </b-col>
      <b-col>
        <label class="impressao--label"
               for="data_de_registro_dia">Dia</label>
        <input id="data_de_registro_dia"
               v-model="impressao.data_de_registro_dia"
               type="number"
               min="0"
               placeholder="N/C"
               :disabled="data_desconhecida"
               class="form-control form-control-sm"
               @keyup="changeImpressao">
      </b-col>
      <b-col>
        <label class="impressao--label"
               for="data_de_registro_mes">Mês</label>
        <input id="data_de_registro_mes"
               v-model="impressao.data_de_registro_mes"
               type="number"
               min="0"
               placeholder="N/C"
               :disabled="data_desconhecida"
               class="form-control form-control-sm"
               @keyup="changeImpressao">
      </b-col>
      <b-col>
        <label class="impressao--label"
               for="data_de_registro_ano">Ano</label>
        <input id="data_de_registro_ano"
               v-model="impressao.data_de_registro_ano"
               type="number"
               min="0"
               placeholder="N/C"
               :disabled="data_desconhecida"
               class="form-control form-control-sm"
               @keyup="changeImpressao">
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col>
        <label class="impressao--label"
               for="declarante">Nome do Declarante</label>
        <input id="declarante"
               v-model="impressao.declarante"
               type="text"
               class="form-control form-control-sm"
               @keyup="changeImpressao">
      </b-col>
      <b-col>
        <label class="impressao--label"
               for="existencia_de_bens">Existência de bens</label>
        <input id="existencia_de_bens"
               v-model="impressao.existencia_de_bens"
               type="text"
               class="form-control form-control-sm"
               @keyup="changeImpressao">
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col>
        <SubHeaderGrey class="row mt-3 mb-1">
          <div class="d-flex justify-content-between pb-1 pl-2">
            Existência de filhos
          </div>
        </SubHeaderGrey>
        <b-row v-for="(filho, index) in filhos"
               :key="index">
          <b-col cols="5">
            <label class="impressao--label"
                   for="nomeFilho">Nome:</label>
            <input id="nomeFilho"
                   v-model="filho.nome"
                   class="form-control form-control-sm"
                   type="text"
                   :name="`filho_nome${index}`"
                   @change="changeFilho(filho)">
          </b-col>
          <b-col cols="5">
            <label class="impressao--label"
                   for="idadeFilho">Idade:</label>
            <input id="idadeFilho"
                   v-model="filho.idade_adaptada"
                   class="form-control form-control-sm"
                   type="text"
                   :name="`idade_nome${index}`"
                   @change="changeFilho(filho)">
          </b-col>
          <b-col cols="1"
                 align-self="center"
                 class="mt-4">
            <b-button size="sm"
                      variant="light"
                      @click="excluirFilho(index)">
              <svg class="obito-show_icon icon--sm"
                   role="presentation">
                <use :xlink:href="'#' + deleteRedIcon.id" />
              </svg>
            </b-button>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12"
             class="mb-2">
        <button variant="primary"
                class="btn btn-sm btn-add-filho btn-outline-primary btn-block my-3"
                size="sm"
                @click="novoFilho">
          <IconSvg class="icon-add icon--sm mr-1"
                   icon="add" />
          Adicionar Filho
        </button>
      </b-col>
    </b-row>





    <b-row class="mt-1">
      <b-col>
        <label class="impressao--label"
               for="averbacoes">Anotações / Averbações</label>
        <div id="averbacoes_anotacoes"
             class="editorHtml text-justify"
             contenteditable="true"
             @blur="getHtml('averbacoes_anotacoes')"
             v-html="impressao.averbacoes_anotacoes" />
      </b-col>
    </b-row>
  </div>

  <!-- fim formulario -->
</template>

<script>
  /* constants */
  import TIPOS_IDADE from "@/constants/tiposIdade"
  import { getDocumentLabel } from "@/constants/documentosPessoais"

  /* components */
  import SubHeaderGrey from "@/components/SofiaRei/Headers/SubHeaderGrey"

  /* icons */
  import deleteRedIcon from '@/assets/icons/delete-red.svg?sprite'

  /* helpers */
  import DataExtensoHelper from "@/helpers/Datas/DataExtensoHelper"

  /* filters */
  import { filterDate, maskCPF } from "@/filters/filters"

  /* libraries */
  import moment from "moment"
  import {mapGetters} from "vuex"

  const mapTiposIdade = {
    A: 'Anos',
    M: 'Meses',
    D: 'Dias',
    I: 'Idade Ignorada'
  }

  export default {
    name: "ImpressaoFormularioObito",
    components: { SubHeaderGrey },
    props: ["data", "orgaoEmissor", "propAverbacoes"],
    data () {
      return {
        sexos: {
          I: 'Ignorado',
          F: 'Feminino',
          M: 'Masculino'
        },
        obito: {},
        data_desconhecida: false,
        impressao: {},
        show: false,
        tipo_idade: {
          A: 'ANOS',
          M: 'MESES',
          D: 'DIAS',
          I: 'IGNORADA'
        },
        objGenitor: {
          nome: ''
        },
        genitores: [],
        deleteRedIcon,
        objFilho: {
          nome: '',
          idade: '',
          idade_adaptada: ''
        },
        filhos: []
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        cartorioObj: 'auth/getCartorioObj'
      }),
      averbacoesAnotacoesAutomaticas () {
        let text = `
          ${this.data.deixa_bens ? 'Deixa bens. ' : 'Não deixa bens. '}
          ${!this.data.deixa_filhos ? 'Não deixa filhos. ' : `Deixa filhos: ${this.data.filhoDeixado.map((filho, i, arr) => { return ` ${filho.nome}${filho.interditado ? `, INTERDITADO(A)${arr.length - 1 === i ? '' : ', '}` : ''}${!!filho.idade ? ` (${filho.idade} ${mapTiposIdade[filho.idade_tipo]})` : ''}${arr.length - 1 === i ? '. ' : ''}` })}`}
          ${this.data.deixa_testamento ? 'Deixa testamento conhecido. ' : 'Não deixa testamento conhecido. '}
        `
        if (!!this.getConjuge()) {
          switch (this.data.pessoa.estado_civil) {
          case 'CASADO':
            text += `Era casado com: ${this.getConjuge()}. `
            break
          case 'CASADA':
            text += `Era casada com: ${this.getConjuge()}. `
            break
          case 'VIÚVO':
            text += `Era viúvo de: ${this.getConjuge()}. `
            break
          case 'VIÚVA':
            text += `Era viúva de: ${this.getConjuge()}. `
            break
          }
        }
        text += `Nada mais me cumpria certificar.`
        return text
      },
    },
    watch: {
      data () {
        this.init()
        this.changeImpressao()
      },
      propAverbacoes () {
        this.init()
        this.changeImpressao()
      }
    },
    async mounted () {
      await this.init()
    },
    methods: {
      getHtml (campo) {
        const html = document.querySelector('#' + campo).innerHTML
        this.impressao[campo] = html
        this.changeImpressao()
      },
      async init () {
        loader({ active: true, text: "Carregando formulário" })
        this.impressao = {}
        if (!this.data.registro || !Object.values(this.orgaoEmissor).length > 0) return setTimeout(() => {
          this.init()
        }, 1000)

        this.show = true
        this.impressao.matricula = this.data.registro.matricula
        this.impressao.nome = this.data.pessoa.nome
        this.impressao.ultimo_convivente = this.data.pessoa.ultimo_convivente || 'NÂO CONSTA'
        this.impressao.cpf =  this.data.pessoa.cpf ? maskCPF(this.data.pessoa.cpf) : 'NÃO CONSTA'

        this.impressao.municipio_de_nascimento = this.data.pessoa.naturalidade
        this.impressao.municipio_de_nascimento_uf = this.data.pessoa.uf || 'N/C'

        this.impressao.municipio_de_nascimento = this.impressao.municipio_de_nascimento == 'Outro' ? this.data.pessoa.naturalidade_declarada : this.impressao.municipio_de_nascimento ? this.impressao.municipio_de_nascimento : 'NÃO CONSTA' 
        this.impressao.estado_civil = (this.data.pessoa.estado_civil && this.data.pessoa.estado_civil || "NÃO CONSTA")

        // Extrair da data de nascimento e dividi-la em componentes separados: dia, mês e ano.
        if (this.data.registro.pessoa.data_nascimento) {
          this.impressao.idade = this.updateTipoIdade()
          
          let data_obj = filterDate(this.data.registro.pessoa.data_nascimento).split('/')
          this.impressao.idade_dia = data_obj.at(0)
          this.impressao.idade_mes = data_obj.at(1)
          this.impressao.idade_ano = data_obj.at(2)
        } else {
          this.impressao.idade = 'NÃO CONSTA'
          this.impressao.idade_dia = 'N/C'
          this.impressao.idade_mes = 'N/C'
          this.impressao.idade_ano = 'N/C'

        }

        this.impressao.sexo = this.sexos[this.data.pessoa.sexo] || 'NÃO CONSTA'
        this.filiacao_residencia()

        this.getFilhos()

        if (!this.filhos.length) {
          this.novoFilho()  
        }

        if (!this.genitores.length) {
          this.novoGenitor()  
        }

        if (this.data.registro.data_ocorrido) {
          let data_obj = filterDate(this.data.registro.data_ocorrido).split('/')
          this.impressao.dia = data_obj[0]
          this.impressao.mes = data_obj[1]
          this.impressao.ano = data_obj[2]
          this.impressao.data_obito = DataExtensoHelper.dataExtenso(this.data.registro.data_ocorrido)
          this.impressao.horario = this.data.registro.hora_ocorrido && moment(this.data.registro.hora_ocorrido, 'H:mm').format('H:mm') + ' horas' || ', hora não informada'
        } else {
          this.impressao.dia = 'N/C'
          this.impressao.mes = 'N/C'
          this.impressao.ano = 'N/C'
          this.impressao.horario = 'N/C'
          this.impressao.data_obito = this.impressao.data_obito || 'NÃO CONSTA'
        }
        
        // Extrair da data do registro e dividi-lo em componentes separados: dia, mês e ano.
        // E também exibir a data por extenso
        if (this.data.registro.data_registro) {          
          let data_obj = filterDate(this.data.registro.data_registro).split('/')
          this.impressao.data_de_registro_dia = data_obj.at(0)
          this.impressao.data_de_registro_mes = data_obj.at(1)
          this.impressao.data_de_registro_ano = data_obj.at(2)

          this.impressao.data_de_registro = DataExtensoHelper.dataExtenso(this.data.registro.data_registro)
        } else {
          this.data.registro.data_de_registro = 'NÃO CONSTA'
          this.impressao.data_de_registro_dia = 'N/C'
          this.impressao.data_de_registro_mes = 'N/C'
          this.impressao.data_de_registro_ano = 'N/C'
        }

        // Verifica se o falecido deixou bens
        this.impressao.existencia_de_bens = this.data.deixa_bens ? 'Sim' : 'Não'

        // Verifica se o falecido tinha filhos
        if (this.data.deixa_filhos) {
          let filhos = this.data.filhoDeixado.reduce((acc, newValue) => acc + newValue.nome + ', ' + newValue.idade + ' anos; ', '')
          this.impressao.existencia_de_filhos = filhos.replace(/;[^;]*$/, '')
        }
        this.impressao.existencia_de_filhos = this.impressao.existencia_de_filhos || 'Não'

        this.localObito()
        this.causasMortes()
        this.medicos()
        this.localSepultamentoCremacao()
        this.declarantes()
        this.averbacoes()
        this.tratarAnotacao()
        this.gerarTextoDeclarante()
        await this.getDocumentos(this.data.pessoa.documentos)

        this.formatDefaultItens()

        this.changeImpressao()
        loader({ active: false })
      },
      declarantes () {
        this.data.registro.partes.map((parte) => {
          if (parte.tipo == "DECLARANTE") {
            this.impressao.declarante = parte.pessoa.nome
          }
        })

        this.impressao.declarante = this.impressao.declarante || 'NÃO CONSTA'
      },
      getDocumentos (documentos) {
        let rg = ''
        let doc = ''

        documentos.map(documento => {
          if (documento.tipo_documento == "RG") {
            let orgaoEmissor = this.orgaoEmissor[documento.codigo_orgao_emissor] && this.orgaoEmissor[documento.codigo_orgao_emissor].split(' - ')[0] || ``
            if (documento.uf_emissor) orgaoEmissor = orgaoEmissor +  '/' + documento.uf_emissor

            rg = `${documento.tipo_documento} ${documento.numero || 'Número não informado'} ${ orgaoEmissor }`
          } else {
            doc = `${getDocumentLabel(documento.tipo_documento)} ${documento.numero || 'Número não informado'}`
          }
        })

        // if (doc && !rg) {
        //   this.impressao.documento_identificacao = doc
        // } else {
        //   this.impressao.documento_identificacao = rg || 'SEM INFORMAÇÃO'
        //   this.impressao.rg = rg || 'SEM INFORMAÇÃO'
        // }
      },
      filiacao_residencia () {
        let genitores_arr = []
        const total_genitores = this.data.pessoa.genitores.length

        this.data.pessoa.genitores.forEach((genitor, index) => {
          this.genitores = [...this.genitores, {nome: genitor.pessoa.nome} ]
          this.impressao.genitores = this.genitores
          
          const genitores = `${index + 1}º Genitor(a): <b>${genitor.pessoa.nome}${(index + 1) === total_genitores ? '' : ';'}</b>`
          genitores_arr.push(genitores)
        })

        this.genitorAdapter(this.genitores)

        
        // let endereco_string = `<br>Reside em: `
        // if (this.data.pessoa && this.data.pessoa.endereco) {
        //   let endereco_obj = this.data.pessoa.endereco

        //   endereco_string += endereco_obj.logradouro || ''
        //   endereco_string += endereco_obj.numero && ', nº ' + endereco_obj.numero || ''
        //   endereco_string += endereco_obj.complemento && ', ' + endereco_obj.complemento || ''
        //   endereco_string += endereco_obj.bairro && ', ' + endereco_obj.bairro + ', em ' || ''
        //   endereco_string += endereco_obj.cidade && endereco_obj.cidade || ''
        //   endereco_string += endereco_obj.uf && ' - ' + endereco_obj.uf || ''
        // } else {
        //   endereco_string += "Não consta"
        // }

        // if (genitores_arr.length > 0) {
        //   this.impressao.genitores = genitores_arr.join(`. <br>`) + ''

        //   this.impressao.genitores = this.impressao.genitores + ". "
        // } else {
        //   this.impressao.genitores = 'Genitores: Não consta'
        // }

        // if (genitores_arr.length > 0) {
        //   this.impressao.genitores = genitores_arr.join(`<br>`) + ''
        //   this.impressao.genitores = this.impressao.genitores

        // } else {
        //   this.impressao.genitores = 'Genitores: Não consta'
        // }

        // if (endereco_string != '<br>Reside em: ') this.impressao.genitores += endereco_string
        // else {
        //   endereco_string += "Não consta"
        //   this.impressao.genitores += endereco_string
        // }
      },
      localObito () {
        let endereco_string = ''
        if (this.data.registro.local != null && this.data.registro.local.endereco_id != null) {
          let endereco_obj = this.data.registro.local.endereco

          if (!!this.data.registro.local.hospital_id) {
            endereco_string += this.data.registro.local.hospital.nome || ''
          }
          else {
            if (this.data.registro.local.descricao) {
              endereco_string += this.data.registro.local.descricao + ', ' || ''
            } 
            
            endereco_string += endereco_obj.logradouro || ''
            endereco_string += endereco_obj.numero && ', nº ' + endereco_obj.numero || ''
            endereco_string += endereco_obj.bairro && ', ' + endereco_obj.bairro || ''
          }

          this.impressao.municipio_obito = endereco_obj.cidade && endereco_obj.cidade || 'NÃO CONSTA'
          this.impressao.uf_obito = endereco_obj.uf && endereco_obj.uf || 'N/C'
          
        } else {
          endereco_string += 'NÃO CONSTA'
          this.impressao.municipio_obito = 'NÃO CONSTA'
          this.impressao.uf_obito = 'N/C'
          
          //municipio_obito
        }

        this.impressao.local_obito = endereco_string || 'NÃO CONSTA'
      },
      causasMortes () {
        let causas = [
          this.data.causa_morte_parte_1_a,
          this.data.causa_morte_parte_1_b,
          this.data.causa_morte_parte_1_c,
          this.data.causa_morte_parte_1_d,
          this.data.causa_morte_parte_2_a,
          this.data.causa_morte_parte_2_b
        ]

        let newCausas = []

        for (let i in causas) {
          if (causas[i] != null) {
            newCausas.push(causas[i])
          }
        }

        this.impressao.causas_morte = newCausas && newCausas.join('; ') || 'NÃO CONSTA'
      },
      medicos () {
        let medico_nome = []
        let medico_crm = []
        let medicos_nomes_strings = ''
        let medicos_crms_strings = ''
        
        this.data.medicos.map(medico => {
          medico_nome.push(`${medico.nome}; `)
          if (medico.crm && medico.uf) medico_crm.push(`${medico.crm}/${medico.uf}; `)
        })

        if (medico_nome.length > 0) {
          medicos_nomes_strings = medico_nome.join(' ').replace(/;[^;]*$/, '')
        } else {
          medicos_nomes_strings = 'Não consta'
        }

        if (medico_crm.length > 0) {
          medicos_crms_strings = medico_crm.join(' ').replace(/;[^;]*$/, '')
        } else {
          medicos_crms_strings = 'Não consta'
        }

        this.impressao.medico_nome = 'Medicos: ' + medicos_nomes_strings
        this.impressao.medico_crm = 'Crms: ' + medicos_crms_strings
      },
      localSepultamentoCremacao () {
        let sepultamento_cremacao_string = ''
        let endereco_string = ''
        let uf_string = ''
        
        if (this.data.sepultamento != null && !!this.data.sepultamento.nome) {
          let sepultamentoCremacao = this.data.sepultamento
          sepultamento_cremacao_string = sepultamentoCremacao.nome || ''

          
          if (!!sepultamentoCremacao.endereco) {
            endereco_string = sepultamentoCremacao.endereco.cidade || ''
            uf_string = sepultamentoCremacao.endereco.uf || ''
          }
        } else {
          sepultamento_cremacao_string = "NÃO CONSTA"
          endereco_string = "NÃO CONSTA"
          uf_string = "N/C"
        }

        this.impressao.sepultamento_cremacao = sepultamento_cremacao_string
        this.impressao.sepultamento_cremacao_municipio = endereco_string
        this.impressao.sepultamento_cremacao_uf = uf_string
      },
      changeImpressao () {
        this.$emit('onChangeImpressao', this.impressao)

        this.cartorio()
      },
      dataDesconhecida () {
        if (!this.data_desconhecida) {
          this.data_antiga = this.impressao.data_obito
          this.dia_antigo = this.impressao.dia
          this.mes_antigo = this.impressao.mes
          this.ano_antigo = this.impressao.ano
          this.impressao.data_obito = "DATA DESCONHECIDA."
          this.impressao.dia = ''
          this.impressao.mes = ''
          this.impressao.ano = ''
          this.changeImpressao()
        } else {
          this.impressao.data_obito = this.data_antiga
          this.impressao.dia = this.dia_antigo
          this.impressao.mes = this.mes_antigo
          this.impressao.ano = this.ano_antigo
          this.changeImpressao()
        }
      },

      cartorio () {
        const cartorio = Object.assign({}, this.cartorioObj)

        Object.assign(this.impressao, { cartorio: cartorio })
      },
      updateTipoIdade () {
        let idade =  null

        if (this.data.registro.pessoa.data_nascimento) {

          const dataNascimento = moment(this.data.registro.pessoa.data_nascimento).format('YYYY-MM-DD')

          let dataComparacao = moment()

          if (this.data.registro.data_ocorrido) {
            dataComparacao = moment(this.data.registro.data_ocorrido)
          }

          const diferenciaEmDias = moment(dataComparacao).diff(dataNascimento, 'days')
          const diferenciaEmMeses = moment(dataComparacao).diff(dataNascimento, 'months')
          const diferenciaEmAnos = moment(dataComparacao).diff(dataNascimento, 'years')

          // fazemos todas as validações em dias, pois dependendo o mês e ano o resultado do moment() não sai preciso
          if (diferenciaEmDias < 30 || diferenciaEmMeses < 1) {
            idade = `${diferenciaEmDias} ${diferenciaEmDias <= 1 ? 'dia' : 'dias'}`
          }

          if (diferenciaEmMeses >= 1 && diferenciaEmMeses < 12) {
            idade = `${diferenciaEmMeses} ${diferenciaEmMeses === 1 ? 'mês' : 'meses'}`
          }

          if (diferenciaEmAnos >= 1) {
            idade = `${diferenciaEmAnos} ${diferenciaEmAnos === 1 ? 'ano' : 'anos'}`
          }

          return idade
        } else {
          return "Não informado"
        }
      },

      averbacoes () {
        let averbacoes = ''
        this.impressao.averbacoes = ''
        this.impressao.averbacao_certidao = ''
        this.impressao.averbacao_livro = ''
        this.impressao.averbacao_transporte = ''

        if (this.propAverbacoes && this.propAverbacoes.length > 0) {
          if (!!averbacoes) averbacoes += '<br>'
          try {
            this.propAverbacoes.forEach((averbacao, i) => {
              const line = averbacao.texto_averbacao

              averbacoes += i === 0 ? line : '<br>' + line

              if (averbacao.averb_acrescida_certidao) this.impressao.averbacao_certidao += line + '<br>'
              if (averbacao.averb_impressa_livro) this.impressao.averbacoes +=  line + '<br>'
              if (averbacao.averb_impressa_transporte) this.impressao.averbacao_transporte += line + '<br>'
            })
          } catch (e) {
            console.error(e)
          }
        }

        //this.impressao.averbacoes = averbacoes || ''
      },

      getConjuge () {
        const casamento = this.data.registro.anteriores.find(anterior => (anterior.tipo_registro === 'C' || anterior.tipo_registro === 'CR') && anterior.registro_atual === 1)

        if (casamento) {
          return casamento.conjuge
        }
      },

      tratarAnotacao ()  {
        this.impressao.averbacoes_anotacoes = this.data.registro.complemento ? this.data.registro.complemento : ''
        this.impressao.averbacoes_anotacoes += this.impressao.averbacao_certidao ? '<br>' + this.impressao.averbacao_certidao : ''
        !this.impressao.averbacoes_anotacoes ? this.impressao.averbacoes_anotacoes = 'NÃO CONSTA' : ''
      },

      tratarEstadoCivil (estadoCivil) {
        if (['VIUVO', 'VIUVA'].indexOf(estadoCivil) !== -1) {
          estadoCivil = estadoCivil.replace('U', 'Ú')
          return estadoCivil
        } else {
          return estadoCivil
        }
      },

      gerarTextoDeclarante () {
        const text = 'Assento de óbito feito de conformidade com as declarações ' +
          `${this.data.convenio_funeraria ? ('prestadas junto ao Serviço Funerário Municipal desta cidade de ' + this.cartorioObj.endereco.cidade + ' - ' + this.cartorioObj.endereco.uf + ', ') : ''}` +
          `pelo(a) Sr(a) ${this.tratarDadosDeclarante()} ` +
          `${this.data.convenio_funeraria === true ? `que subscreveu a declaração de nº  <b>${this.data.numero_declaracao_funeraria || 'não informado'}</b>, <br> a qual se encontra arquivada nesta Unidade de Serviço. ` : ``}`  
        this.impressao.texto_declarante = text
      },
      tratarDadosDeclarante () {
        const { partes } = this.data.registro

        if (!partes || !partes.length) return 'não informado'

        const declarante = partes.find(parte => parte.tipo == 'DECLARANTE')

        if (!declarante) return 'não informado'

        const { pessoa } = declarante

        const assinatura_declarante =  declarante.pessoa.nome || null
        this.impressao.assinatura_declarante = assinatura_declarante

        const text = `${pessoa.nome}, ${pessoa.nacionalidade ? `de nacionalidade ${pessoa.nacionalidade.nome_feminino},`  : ''} ` +
          `${pessoa.estado_civil && ['IGNORADO', 'OUTROS'].indexOf(pessoa.estado_civil) == -1 ? this.tratarEstadoCivil(pessoa.estado_civil).toLowerCase() + '(a),' : ''} ` +
          `${pessoa.ocupacao_declarada ? pessoa.ocupacao_declarada + ',' : ''} ` +
          `${pessoa.cpf ? `CPF: ` + maskCPF(pessoa.cpf) + ',' : ''} ` +
          `${this.tratarDocumentos(pessoa.documentos)} ${pessoa.endereco ? `${this.tratarEndereco(pessoa.endereco)}` : ''}`

        return text
      },
      tratarEndereco (endereco) {
        if (!endereco.logradouro && !endereco.cidade && !endereco.uf) {
          return ''
        } else if (!endereco.logradouro && endereco.cidade && endereco.uf) {
          return `residente e domiciliado em ${endereco.cidade} -  ${endereco.uf},`
        } else if (endereco.logradouro) {
          return `residente e domiciliado na ${endereco.logradouro}, ${endereco.numero ? ' nº ' + endereco.numero : ''}, ` +
            `${endereco.bairro || ''}, ${endereco.cidade || ''} ${endereco.cidade && endereco.uf ? '-' : ''} ${endereco.uf || ''}`
        } else return ''
      },
      tratarDocumentos (documentos) {
        if (!documentos.length) return ''

        const rg = documentos.find(documento => documento.tipo_documento == 'RG')

        if (!rg) {
          const documento = documentos[0]

          return `${getDocumentLabel(documento.tipo_documento)} ${documento.numero},`
        } else  {
          const orgao_emissor = this.orgaoEmissor[rg.codigo_orgao_emissor]
          const sigla = orgao_emissor && orgao_emissor.split(' ') || null

          return `RG ${rg.numero} - ${(sigla && sigla[0]) && sigla[0] + '/' || '' }${rg.uf_emissor},`
        }
      },

      novoGenitor () {
        let obj = {...this.objGenitor}
        this.genitores.push(obj)
        this.changeImpressao()
      },

      changeGenitor (genitor, index) {
        this.genitores[index] = genitor
        this.impressao.genitores = this.genitores
        this.genitorAdapter(this.impressao.genitores)
        this.changeImpressao()
      },

      excluirGenitor (index) {
        if (!!this.genitores) {
          this.impressao.genitores = null
          let genitores = this.genitores.splice(index, 1)
          this.genitorAdapter(this.genitores)
        }
      },

      genitorAdapter (genitores) {
        if (genitores) {
          let genitores_arr = []
          genitores.forEach((genitor, index) => {
            let genitoresText = `${genitor.nome}${(index + 1) === genitores.length ? '' : ';'}`
            genitores_arr.push(genitoresText)
          })

          if (!!genitores_arr) {
            this.impressao.genitores = genitores_arr.join(` `) + ''
          } 
        }

        this.changeImpressao()
        
      },

      getFilhos () {
        if (!!this.data.deixa_filhos && !!this.data.filhoDeixado) {
          this.filhos = this.data.filhoDeixado

          this.filhos.forEach((filho, index) => {
            if (!!filho.idade) {
              this.filhos[index].idade_adaptada = filho.idade + this.idadeAdapter(filho.idade, filho.idade_tipo) // ex: 20 anos 
              this.filhos[index].idade_numero = filho.idade // ex 20
            }
          })
          this.impressao.filhos = this.filhos
          this.filhoAdapter(this.filhos)
        }
      },

      idadeAdapter (idade, tipo) {
        switch (tipo) {
        case 'A': 
          return idade == '1' ? ' ANO' : ' ANOS'
        case 'M': 
          return idade == '1' ? ' MÊS' : ' MESES'
        case 'D': 
          return idade == '1' ? ' DIA' : ' DIAS'
        default:
          return ''
        }
      },

      novoFilho () {
        let obj = {...this.objFilho}
        this.filhos.push(obj)
        this.changeImpressao()
      },

      async changeFilho (filho, index) {
        this.filhos[index] = filho
        !!filho.idade_adaptada ? this.filhos[index].idade = filho.idade_adaptada.replace(/[^0-9]/g,'') : '' // Condição para manter salvo somente o numero da idade
        this.impressao.filhos = this.filhos
        this.filhoAdapter(this.impressao.filhos)
        this.changeImpressao()
      },

      excluirFilho (index) {
        if (!!this.filhos) {
          this.impressao.filhos = null
          let filhos = this.filhos.splice(index, 1)
          this.filhoAdapter(this.filhos)
        }
      },

      filhoAdapter (filhos) {
        if (filhos) {
          let filhos_arr = []
          filhos.forEach((filho, index) => {
            let filhosText = `${filho.nome}${(!!filho.idade_adaptada) ? ', ' + filho.idade_adaptada : ''}${(index + 1) === filhos.length ? '' : ';'}`
            filhos_arr.push(filhosText)
          })

          if (!!filhos_arr) {
            this.impressao.filhosText = filhos_arr.join(` `) + ''
          } 
        }

        this.changeImpressao()
        
      },

      formatDefaultItens () {
        !this.impressao.estado_civil ? this.impressao.estado_civil = 'NÃO CONSTA' : '' 
        !this.impressao.municipio_de_nascimento_uf ? this.impressao.municipio_de_nascimento_uf = 'N/C' : ''
      }
    }
  }
</script>

<style scoped>
  #formulario input, #formulario textarea {
    text-transform: uppercase;
  }

  .editorHtml {
    min-height: 50px;
    border: 1px solid #CCC;
    padding: 10px;
    border-radius: 3px;
    background-color: #FFFFFF;
  }
  
  .delete-genitor {
    padding-top: 3%;
    padding-right: 3%;

  }

  .btn-add-genitor:hover:not(:disabled) > [class*=icon-add] {
    fill: #fff !important;
  }

  .btn-add-filho:hover:not(:disabled) > [class*=icon-add] {
    fill: #fff !important;
  }

  .icon-add {
    fill: #1c7af5 !important;
    width: 16px;
    height: 16px;
    transition: fill 0.2s;
  }
</style>
